module.exports = __webpack_public_path__ + "img/06.5acb7a37.png";